import { render } from "./Anonymize.vue?vue&type=template&id=accae806"
import script from "./Anonymize.vue?vue&type=script&lang=js"
export * from "./Anonymize.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__